import {SUPPORTS_SYMBOL} from "./constructor";

export const SUPPORTS_SYMBOL_SPLIT = SUPPORTS_SYMBOL && "split" in Symbol;
